import {Component} from '@angular/core';
/**
 * \@title Datepicker Min Max
 */
export class DatepickerMinMaxExample {
  minDate = new Date(2000, 0, 1);
  maxDate = new Date(2020, 0, 1);
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-min-max-example',
  templateUrl: 'datepicker-min-max-example.html',
  styleUrls: ['datepicker-min-max-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerMinMaxExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerMinMaxExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerMinMaxExample.ctorParameters;
/** @type {?} */
DatepickerMinMaxExample.prototype.minDate;
/** @type {?} */
DatepickerMinMaxExample.prototype.maxDate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
